<template>
  <div class="container mx-auto">
    <div class="flex flex-col lg:flex-row flex-wrap min-h-screen lg:h-screen content-center items-center">
      <div class="w-full lg:w-1/2">
        <div class="coronaGirl p-2" v-if="$i18n.locale == 'ar'">
          <img class="mx-auto w-64 lg:w-auto" src="../assets/coronagirlar.svg" alt="Corona Girl">    
        </div>
        <div class="coronaGirl p-2" v-if="$i18n.locale == 'fr'">
          <img class="mx-auto w-64 lg:w-auto" src="../assets/coronagirlfr.svg" alt="Corona Girl">    
        </div>
        <div class="coronaGirl p-2" v-if="$i18n.locale == 'en'">
          <img class="mx-auto w-64 lg:w-auto" src="../assets/coronagirlen.svg" alt="Corona Girl">    
        </div>
      </div>
      <div class="w-full lg:w-1/2">
        <div class="infos p-8 lg:p-2 text-center" :class="($i18n.locale == 'ar' ? 'lg:text-right' : 'lg:text-left')">
          <h1 class="font-bold text-3xl lg:text-6xl mb-8" :class="(dark) ? 'text-white' : 'text-yellow'">{{ $t('home.title') }}</h1>
          <p class="text-xl lg:text-2xl mb-8" :class="(dark) ? 'text-white' : 'text-yellow'">{{ $t('home.desc') }}</p>
          <router-link :to="`/${$i18n.locale}/stats`" class="inline-block text-base lg:text-xl text-white px-10 py-4 rounded" :class="(dark) ? 'bg-sideDark' : 'bg-sideLight'">{{ $t('home.btn') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Home',
  computed: {
    dark () {
      return this.$store.state.dark
    }
  }
}
</script>
